<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">UPDATE EMAIL</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <form action @submit.prevent="updateUserEmail">
          <div
            class="font-14 color_grey_dark mb-4"
          >Please verify that your email address is correct.</div>

          <!-- ERROR/SUCCESS ALERT -->
          <div style="position: relative; top: -20px; margin-bottom: -15px;">
            <AuthAlertCard v-if="show_alert" :alert_type="alert_type" :alert_msg="alert_msg"></AuthAlertCard>
          </div>

          <div class="container mt-3">
            <!-- EMAIL -->
            <div class="modal-body-row row">
              <label for class="text-uppercase control-label color_grey_dark">New Email Address</label>
              <input
                type="email"
                v-model="form.email"
                class="form-control"
                placeholder="Enter email sddress"
                ref="emailInput"
                @input="checkInput"
              >
            </div>

            <!-- PASSWORD -->
            <div class="modal-body-row row">
              <label for class="text-uppercase control-label color_grey_dark">Password</label>
              <input
                type="password"
                v-model="form.confirm_password"
                class="form-control"
                placeholder="For security, Please confirm your password"
                ref="passwordInput"
                @input="checkInput"
              >
            </div>
          </div>

          <!-- CANCEL OR SUBMIT FORM -->
          <div
            class="modal-body-row row d-flex justify-content-center align-items-center nowrap mb-2"
          >
            <button @click="dropModal" class="btn btn-md black-ic z-depth-0 mr-4">Cancel</button>
            <button type="submit" class="btn btn-md btn-accent ml-4" ref="updateBtn">Update</button>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";
import { setTimeout } from "timers";

export default {
  name: "UpdateEmailModal",

  props: ["alertDetails"],

  components: {
    Modal,
    AuthAlertCard: () =>
      import(/* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard")
  },
  data() {
    return {
      form: {
        email: null,
        confirm_password: null
      },
      account_type: null,
      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null
    };
  },

  mounted() {
    this.$refs.updateBtn.disabled = true;
    this.getAccountType();
  },

  methods: {
    ...mapActions(["updateEmail", "updateUserState"]),

    checkInput() {
      let email_input = this.$refs.emailInput.value;
      let password_input = this.$refs.passwordInput.value;

      email_input.length > 0 && password_input.length > 5
        ? (this.$refs.updateBtn.disabled = false)
        : (this.$refs.updateBtn.disabled = true);
    },

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
    },

    dropModal() {
      this.$emit("closeTriggered");
    },

    updateUserEmail() {
      this.$refs.updateBtn.disabled = true;
      this.$refs.updateBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Updating...';

      const accountType = this.account_type;
      const data = this.form;

      this.updateEmail({ data, accountType })
        .then(res => {
          if (res.code === 200) {
            setTimeout(() => {
              this.show_alert = false;

              this.$refs.updateBtn.disabled = true;
              this.$refs.updateBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2"></div>Successful.';
            }, 1000);

            setTimeout(() => {
              this.updateUserState();
              let dialog_data = {
                msg: "Email was updated successfully...",
                type: "success"
              };
              this.$emit("showAlertCard", dialog_data);
              this.dropModal();
            }, 3000);
          }
          // HANDLE A NON 200 RESPONSE
          else {
            this.show_alert = true;
            this.alert_type = "error";

            if (res.message === "Network Error") {
              this.alert_msg = "0ops! No internet connection, try again!";
            } else if (res.code === 406) {
              this.alert_msg =
                res.data.email.length === 1
                  ? res.data.email[0]
                  : res.data.confirm_password[0];
            } else {
              this.alert_msg = "An error occured, please try again!";
            }

            this.$refs.updateBtn.disabled = true;
            this.$refs.updateBtn.innerHTML = "Update";

            setTimeout(() => {
              this.show_alert = false;
              this.alert_type = null;
              this.alert_msg = null;
            }, 5000);
          }
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style>
</style>
